export default{
    title: 'Πίνακας ελέγχου',
    welcome: 'Kαλώς όρισες στο athlisis',
    educational: 'Educational',
    welcomeText: 'Tη No1 εφαρμογή για διατροφολόγους στην Ελλάδα!',
    confirmEmail: {
        title: 'Δεν έχετε επιβεβαιώσει το e-mail σας.',
        cta: 'Επαναποστολή συνδέσμου επιβεβαίωσης'
    },
    news: {
        title: 'Τελευταία νέα',
        subtitle: 'Διάβασε τα τελευταία μας νέα στο blog του athlisis',
        cta: 'Δες το άρθρο'
    },

    birthdays: {
        title: 'Πελάτες που έχουν γενέθλια στον μήνα',
        subtitle: 'Μην ξεχάσεις να τους ευχηθείς!',
        noResults: 'Δεν υπάρχουν άλλα γενέθλια αυτόν τον μήνα',
        noResultsText: 'Εμφανίζονται μόνο πελάτες με συμπληρωμένη ημερομηνία γέννησης.',
        phone: 'Τηλ:',
        cta: 'Προβολή',
    },
    addAthlete: 'Προσθήκη πελάτη',
    addAppointment: 'Προσθήκη ραντεβού',
    addAppointmentModalTitle: 'Προσθήκη νέου ραντεβού',
    events: {
        title: 'Ραντεβού ημέρας',
        subtitle: 'Δες τα επόμενα ραντεβού της ημέρας σου',
        noEvents: 'Δεν έχεις άλλα ραντεβού σήμερα',
        noEventsText: 'Αν κλείσεις νέο ραντεβού για σήμερα, θα εμφανιστεί εδώ.',
        showCancelledQ: 'Εμφάνιση ακυρωμένων ραντεβού;',
        cancelled: 'Ακυρωμένο',
        dailyAppointments: 'Ραντεβού ημέρας',
        hour: 'Ώρα',
        client: 'Πελάτης - Σημείωση',
        next: {
            ongoing: 'Έχεις ραντεβού σε εξέλιξη αυτή τη στιγμή',
            startsIn: 'Το επόμενο ραντεβού σου ξεκινά σε {time}',
            hours: '{count} ώρα | {count} ώρες',
            minutes: '{count} λεπτό | {count} λεπτά',
            and: 'και',
        },
    },
    todo: {
        title: 'Λίστα to-do',
        active: 'Ενεργά',
        completed: 'Ολοκληρωμένα',
        add: 'Προσθήκη νέου to-do',
        emptyActive: 'Όλα έτοιμα',
        emptyActiveText: 'Δεν έχεις καμία εκκρεμότητα.',
        emptyCompleted: 'Δεν υπάρχουν ολοκληρωμένα to-do ακόμα',
        emptyCompletedText: 'Ό,τι ολοκληρώνεις θα εμφανίζεται εδώ.',
        dateToday: 'σήμερα',
        dateYesterday: 'χθες',
        dateDaysAgo: 'πριν από {days} μέρες'
    },
    aiAgents: {
        title: 'Το AI bridge έφτασε',
        text: 'Δώσε σε Claude, ChatGPT ή οποιοδήποτε AI agent, πρόσβαση στο λογαριασμό σου και αναβάθμισε με την καθημερινότητά σου.',
        connect: 'Ξεκίνα εδώ',
    },
    marketplace: {
        title: 'Το vresdiatrofologo έφτασε',
        text: 'Φτιάξε τώρα δωρεάν το προφίλ σου, για να είσαι από τους πρώτους!',
        createAccount: 'Δημιούργησε λογαριασμό',
        readMore: 'Μάθε περισσότερα',
        panel: {
            title: 'vresdiatrofologo',
            videoPlaceholder: 'Σύντομα εδώ θα δεις ένα σύντομο βίντεο παρουσίασης.',
            p1: 'Το <strong>vresdiatrofologo.gr</strong> είναι το νέο εργαλείο του Athlisis για τον σύγχρονο διαιτολόγο.',
            p2: 'Κάθε μέρα άνθρωποι ψάχνουν διαιτολόγο online — το θέμα δεν είναι αν ψάχνουν, αλλά αν βρίσκουν εσένα.',
            p3: 'Με το vresdiatrofologo δημιουργείς το προφίλ σου και εμφανίζεσαι με βάση την εξειδίκευση, το κοινό και τα αποτελέσματά σου, ώστε όταν κάποιος αναζητά επαγγελματία να σε βρίσκει εύκολα, σωστά και ψηλά.',
            p4: 'Η πλατφόρμα εξελίσσεται συνεχώς με στόχο να γίνει σημείο αναφοράς για τον κλάδο, και όσοι μπουν νωρίς εξασφαλίζουν προτεραιότητα στην προβολή τους.',
            p5: 'Η διαδικασία είναι απλή και διαρκεί μόλις 3–5 λεπτά, ενώ αυτή τη στιγμή είναι δωρεάν αποκλειστικά για χρήστες του Athlisis, ως ένα επιπλέον εργαλείο ανάπτυξης του επαγγελματικού σου προφίλ.',
            p6: 'Ξεκίνα τώρα και πάρε θέση από τους πρώτους.',
            cta: 'Συνέχισε στο vresdiatrofologo',
            ctaHelper: 'Θα συνδεθείς αυτόματα με τον λογαριασμό του athlisis.',
        }
    }
}
